import { useState } from "react";
import Button, { ButtonProps } from "@mui/material/Button";

interface DebouncedButtonProps extends ButtonProps {
  debounceTime?: number;
}

function DebouncedButton({
  debounceTime = 1000,
  onClick,
  disabled,
  ...props
}: DebouncedButtonProps) {
  const [isDisabled, setIsDisabled] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), debounceTime);
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Button
      {...props}
      disabled={isDisabled || disabled === true}
      onClick={handleClick}
    />
  );
}

export default DebouncedButton;
